import React from 'react';
import { Section } from '../ui/Section';
import { SectionTitle, Accent } from '../ui/SectionTitle';
import { IconByName } from '../ui/IconByName';
import { blockers } from '../../data/content';
export function BlockersSection() {
  return <Section id="bloqueos" tone="surface" data-id="element-90" data-mp="3b9kcinr8zxwo">
      <SectionTitle className="max-w-4xl" data-id="element-91" data-mp="3g9ykk5sun7up">
        En tu diagnóstico vamos a identificar <Accent data-id="element-92" data-mp="3g7u7oycz2yia">qué está bloqueando</Accent> tu progreso.
      </SectionTitle>

      <ul className="mt-14 grid gap-px overflow-hidden rounded-lg border border-line bg-line sm:grid-cols-2 lg:grid-cols-3" data-id="element-93" data-mp="3l91eov7ajtnw">
        {blockers.map(b => <li key={b.title} className="flex flex-col bg-ink p-7 sm:p-8" data-id="element-94" data-mp="3uyupvv3iu6rm">
            <span className="flex h-11 w-11 items-center justify-center rounded-md border border-brand/40 bg-brand/10" data-id="element-95" data-mp="2v28cx4fh2ic">
              <IconByName name={b.icon} className="h-5 w-5 text-brand" data-id="element-96" data-mp="7v6f3vfjaivd" />
            </span>
            <h3 className="mt-6 font-display text-2xl font-bold uppercase leading-tight text-white" data-id="element-97" data-mp="csyj3ntgdvfx">{b.title}</h3>
            <p className="mt-3 leading-relaxed text-muted" data-id="element-98" data-mp="ow0g5evkl9ed">{b.text}</p>
          </li>)}
      </ul>
    </Section>;
}